// ─── « Où est-ce rangé ? » — plan interactif de localisation ──────
// Modale dédiée, bâtie sur le template <Calque> du Core. Montre le plan 2D du
// niveau courant (zone cible surlignée) ; on tape une zone pour y descendre, la
// flèche ‹ remonte d'un niveau. Rendu en calque (pas un 2e <Modal>) → empilable
// au-dessus de la fiche.
import React, { useEffect, useMemo, useState } from 'react';
import { Text, StyleSheet } from 'react-native';
import { useUI, useT, Calque } from '@mop/core';
import { noeudParId, parentDe, cheminDe } from './services/inventaires';
import { cheminIdsEmp } from './services/plan';
import PlanGrid from './ui/PlanGrid';

export default function LocalisationModal({
  visible, emplacementId, emplacements = [], racineNom = 'Foyer', racineEmoji = '🏠',
  compteDe, onFermer,
}) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);

  const chemin = useMemo(() => cheminIdsEmp(emplacements, emplacementId), [emplacements, emplacementId]);
  const [niveau, setNiveau] = useState(null);   // lieu dont on affiche le plan (null = racine/foyer)

  useEffect(() => {
    if (!visible) return;
    setNiveau(chemin.length > 1 ? chemin[0] : null);   // on ouvre au niveau de la « maison »
  }, [visible, emplacementId]); // eslint-disable-line react-hooks/exhaustive-deps

  const parent = niveau
    ? noeudParId(emplacements, niveau)
    : { id: null, nom: racineNom, emoji: racineEmoji, enfants: emplacements, planCols: 3, planRows: 0, planMurs: [] };

  const remonter = () => {
    if (!niveau) { onFermer?.(); return; }
    const p = parentDe(emplacements, niveau);
    setNiveau(p && p.parent ? p.parent.id : null);
  };

  return (
    <Calque visible={visible} titre={t('inventaire.ouEstCeRange')} onRetour={remonter} onFermer={onFermer}>
      <Text style={s.chemin}>📍 {cheminDe(emplacements, emplacementId)}</Text>
      {(parent.enfants || []).length > 0 ? (
        <PlanGrid parent={parent} flux cibleIds={chemin} onTapTuile={(n) => setNiveau(n.id)} compteDe={compteDe} />
      ) : (
        <Text style={s.vide}>{t('inventaire.niveauSansSousEmplacement')}</Text>
      )}
      <Text style={s.aide}>
        {t('inventaire.planViewAide')}
      </Text>
    </Calque>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  chemin: { fontSize: 14, color: UI.muted, fontWeight: '600', marginBottom: 12 },
  vide:   { fontSize: 13.5, color: UI.muted, marginVertical: 20 },
  aide:   { fontSize: 12, color: UI.faint, textAlign: 'center', marginTop: 14, lineHeight: 17 },
});
